(() => {
  const start = () => {
    let activeDrawer = null;
    let activeImageViewer = null;
    let imageTrigger = null;
    let activeOverlay = null;
    let activeAddon = null;
    let lastTrigger = null;
    let pendingAccountFocus = null;
    let pendingBundleFocus = null;
    const cartStatus = document.getElementById('AcCartStatus');
    const labels = cartStatus?.dataset || {};
    document.addEventListener('invalid',event=> {
      const input=event.target;
      if(!input.id || !input.closest('#ActiviteaEventForm,#ActiviteaNewsletter,[data-login-form],[data-register-form],[data-recover-form],.f-popup__form')) return;
      const id=input.id+'-validation';
      let message=document.getElementById(id);
      if(!message) { message=document.createElement('p');message.id=id;message.className='ac-field-error';input.insertAdjacentElement('afterend',message); }
      message.textContent=input.validationMessage || labels.fieldError || 'Please check this field.';
      input.setAttribute('aria-invalid','true');
      const descriptions=new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      descriptions.add(id); input.setAttribute('aria-describedby',Array.from(descriptions).join(' '));
    },true);
    const clearValidation=event=> {
      const input=event.target;
      const message=input.id && document.getElementById(input.id+'-validation');
      if(!message || !input.validity.valid) return;
      message.remove();input.removeAttribute('aria-invalid');
      const descriptions=(input.getAttribute('aria-describedby') || '').split(/\s+/).filter(id=>id && id!==input.id+'-validation');
      if(descriptions.length) input.setAttribute('aria-describedby',descriptions.join(' '));else input.removeAttribute('aria-describedby');
    };
    document.addEventListener('input',clearValidation);
    document.addEventListener('change',clearValidation);
    const focusSelector = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
    const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert],[hidden]');
    const controls = dialog => Array.from(dialog.querySelectorAll(focusSelector)).filter(visible);
    const focusFirst = dialog => (controls(dialog)[0] || dialog).focus({preventScroll:true});
    const setAttribute = (element,name,value) => { if (element.getAttribute(name) !== value) element.setAttribute(name,value); };
    const imageKey = url => {
      try { return new URL(url,location.href).pathname.split('/').pop().replace(/_\d+x\d*(?=\.)/,''); }
      catch { return ''; }
    };
    const describeImages = dialog => {
      const originals = Array.from(document.querySelectorAll('.sf-prod-media img[alt]')).filter(image=>image.alt);
      dialog.querySelectorAll('.gslide-image img').forEach(image => {
        const original = originals.find(candidate=>imageKey(candidate.currentSrc || candidate.src) === imageKey(image.currentSrc || image.src));
        if (original) setAttribute(image,'alt',original.alt);
      });
    };
    const isolate = dialog => {
      const background = [];
      for (let branch=dialog; branch.parentElement; branch=branch.parentElement) {
        Array.from(branch.parentElement.children).forEach(sibling=> {
          if (sibling !== branch && !sibling.matches('script,style,link,template,#AcCartStatus')) {
            background.push([sibling,sibling.inert]); sibling.inert=true;
          }
        });
        if(branch.parentElement === document.body) break;
      }
      return background;
    };
    const releaseOverlay = (state,restoreFocus) => {
      if (!state) return;
      state.background.forEach(([element,wasInert])=>{element.inert=wasInert;});
      state.dialog.removeAttribute('role');
      state.dialog.removeAttribute('aria-modal');
      if (restoreFocus && state.trigger?.isConnected && visible(state.trigger)) state.trigger.focus({preventScroll:true});
    };
    const openOverlay = (dialog,closeButton,trigger) => {
      const title = dialog.querySelector('.scd__addon-title,.scd__header h3,h1,h2,h3,.sf__product-title');
      setAttribute(dialog,'role','dialog'); setAttribute(dialog,'aria-modal','true'); setAttribute(dialog,'tabindex','-1');
      setAttribute(dialog,'aria-label',title?.textContent.trim() || labels.dialog || document.title);
      if (closeButton) {
        if(closeButton.tagName === 'BUTTON') setAttribute(closeButton,'type','button');
        else {setAttribute(closeButton,'role','button');setAttribute(closeButton,'tabindex','0');}
        if(!closeButton.textContent.trim() && !closeButton.getAttribute('aria-label')) setAttribute(closeButton,'aria-label',labels.closeDialog || 'Close dialog');
      }
      const state={dialog,closeButton,trigger,background:isolate(dialog)};
      focusFirst(dialog);
      return state;
    };
    const syncOverlays = () => {
      const addon = document.querySelector('.scd__addon.open');
      if(activeAddon && activeAddon.dialog !== addon) { const old=activeAddon;activeAddon=null;releaseOverlay(old,true); }
      const drawer = document.querySelector('#cart-drawer-container .scd__wrapper:not(.hidden) .scd__content');
      let popup = document.querySelector('.sf-modal__wrapper.opacity-100 .sf-modal__content');
      const newsletterPopup=popup?.querySelector('.f-popup');
      if(newsletterPopup && !visible(newsletterPopup)) {
        popup.querySelector('.sf-modal__close')?.click();
        popup=null;
      }
      const dialog=popup || drawer;
      if(activeOverlay && activeOverlay.dialog !== dialog) { const old=activeOverlay;activeOverlay=null;releaseOverlay(old,true); }
      if(dialog && !activeOverlay) activeOverlay=openOverlay(dialog,dialog.querySelector('.sf-modal__close,.scd__close'),lastTrigger || document.activeElement);
      if(addon && !activeAddon) activeAddon=openOverlay(addon,addon.querySelector('.btn-cancel'),lastTrigger || document.activeElement);
      document.querySelectorAll('.scd__footer-actions [data-open]').forEach(button=>setAttribute(button,'aria-expanded',String(addon?.id === 'scd-'+button.dataset.open)));
    };
    const enhanceNewsletterPopup = () => {
      document.querySelectorAll('.f-popup__input').forEach(input => {
        if (!input.id) input.id='AcPopupEmail';
        setAttribute(input,'autocomplete','email');
        input.required=true;
        if (!input.labels?.length) {
          const label=document.createElement('label');
          label.htmlFor=input.id;
          label.className='ac-popup-email-label';
          label.textContent=labels.popupEmail || 'Email *';
          input.insertAdjacentElement('beforebegin',label);
        }
      });
    };
    const enhanceBundles = () => {
      document.querySelectorAll('[data-bundle-container] form[data-product-id]').forEach(form=> {
        const titleLink=Array.from(form.querySelectorAll('a[href]')).find(link=>link.getAttribute('href').includes('/products/') && link.textContent.trim());
        const name=form.querySelector('.prod__title')?.textContent.trim() || titleLink?.textContent.trim();
        if(!name) return;
        form.querySelectorAll('select').forEach(select=>setAttribute(select,'aria-label',(labels.bundleOptions || 'Options for')+' '+name));
        form.querySelectorAll('.select-button').forEach(button=> {
          setAttribute(button,'aria-label',(labels.bundleInclude || 'Include in bundle:')+' '+name);
          setAttribute(button,'aria-pressed',String(button.classList.contains('selected') || button.classList.contains('main-prod')));
          setAttribute(button,'type','button');
        });
        form.querySelectorAll('input[name="quantity"]').forEach(input=>setAttribute(input,'aria-label',(labels.bundleQuantity || 'Quantity for')+' '+name));
      });
      if(pendingBundleFocus) {
        const {button,pressed}=pendingBundleFocus;
        if(!button.isConnected) pendingBundleFocus=null;
        else if(button.getAttribute('aria-pressed') !== pressed) {
          pendingBundleFocus=null;
          if(visible(button) && (document.activeElement===document.body || document.activeElement===button)) button.focus({preventScroll:true});
        }
      }
    };
    let cartFingerprint = null;
    let cartAnnouncementTimer;
    let pendingCartFocus = null;
    const syncCart = () => {
      const cart=document.querySelector('.template-cart [data-cart-wrapper]') || document.querySelector('#cart-drawer-container .scd__content');
      if(!cart || !cartStatus) return;
      const subtotal=cart.querySelector('[data-cart-subtotal]')?.textContent.replace(/\s+/g,' ').trim();
      const quantities=Array.from(cart.querySelectorAll('input[name="updates[]"]')).map(input=>input.value).join(',');
      const fingerprint=JSON.stringify([subtotal,quantities]);
      if(cartFingerprint !== null && cartFingerprint !== fingerprint && subtotal) {
        clearTimeout(cartAnnouncementTimer);
        cartAnnouncementTimer=setTimeout(()=>{
          cartStatus.textContent=labels.prefix+' '+subtotal;
          if(pendingCartFocus && document.activeElement === document.body) {
            const replacement=Array.from(cart.querySelectorAll('[aria-label]')).find(element=>element.getAttribute('aria-label')===pendingCartFocus && visible(element));
            (replacement || controls(cart)[0])?.focus({preventScroll:true});
          }
          pendingCartFocus=null;
        },250);
      }
      cartFingerprint=fingerprint;
    };
    const modal = sidebar => window.matchMedia('(max-width:1279px)').matches || sidebar.dataset.type === 'fixed';
    const releaseImageViewer = restoreFocus => {
      if (!activeImageViewer) return;
      const state = activeImageViewer;
      activeImageViewer = null;
      state.background.forEach(([element, wasInert]) => { element.inert = wasInert; });
      if (restoreFocus && state.trigger?.isConnected && visible(state.trigger)) state.trigger.focus({preventScroll:true});
    };
    const syncImageViewer = () => {
      const dialog = document.querySelector('.glightbox-container[role="dialog"]');
      if (dialog) describeImages(dialog);
      if (activeImageViewer && activeImageViewer.dialog !== dialog) releaseImageViewer(true);
      if (!dialog || activeImageViewer) return;
      const background = Array.from(document.body.children)
        .filter(element => element !== dialog && !element.matches('script,style,link,template'))
        .map(element => [element,element.inert]);
      background.forEach(([element]) => { element.inert = true; });
      activeImageViewer = {dialog,trigger:imageTrigger,background};
      dialog.setAttribute('aria-modal','true');
      dialog.setAttribute('aria-label',document.querySelector('h1')?.textContent.trim() || imageTrigger?.getAttribute('aria-label') || document.title);
      focusFirst(dialog);
    };
    const release = restoreFocus => {
      if (!activeDrawer) return;
      const state = activeDrawer;
      activeDrawer = null;
      state.background.forEach(([element, wasInert]) => { element.inert = wasInert; });
      document.body.style.overflow = state.overflow;
      state.dialog.removeAttribute('role');
      state.dialog.removeAttribute('aria-modal');
      state.trigger?.setAttribute('aria-expanded','false');
      if (restoreFocus && state.trigger?.isConnected && visible(state.trigger)) state.trigger.focus({preventScroll:true});
    };
    const activate = (sidebar, section, trigger) => {
      const dialog = sidebar.querySelector('.sf__sidebar-content');
      if (!dialog) return;
      const background = [];
      for (let branch = dialog; branch.parentElement; branch = branch.parentElement) {
        Array.from(branch.parentElement.children).forEach(sibling => {
          if (sibling !== branch && !sibling.matches('script,style,link,template')) {
            background.push([sibling,sibling.inert]);
            sibling.inert = true;
          }
        });
        if (branch.parentElement === document.body) break;
      }
      activeDrawer = {sidebar,section,dialog,trigger,background,overflow:document.body.style.overflow};
      document.body.style.overflow = 'hidden';
      dialog.setAttribute('role','dialog');
      dialog.setAttribute('aria-modal','true');
      dialog.setAttribute('aria-label',sidebar.dataset.acDialogLabel);
      dialog.setAttribute('tabindex','-1');
      trigger?.setAttribute('aria-expanded','true');
      focusFirst(dialog);
    };
    const sync = () => {
      if(pendingAccountFocus) {
        const input=document.querySelector(pendingAccountFocus);
        if(input && visible(input)) {pendingAccountFocus=null;input.focus({preventScroll:false});}
      }
      document.querySelectorAll('.swiper-wrapper > .sf-prod-media-item').forEach(slide=> {
        const inactive=!slide.classList.contains('swiper-slide-active');
        slide.inert=inactive;
        if(inactive) setAttribute(slide,'aria-hidden','true');else slide.removeAttribute('aria-hidden');
      });
      if (activeDrawer && (!activeDrawer.sidebar.isConnected || !activeDrawer.dialog.isConnected || !activeDrawer.section.classList.contains('sidebar-open') || !modal(activeDrawer.sidebar))) release(true);
      document.querySelectorAll('section[data-section-type="collection-template"] .sf__sidebar').forEach(sidebar => {
        const section = sidebar.closest('section[data-section-type="collection-template"]');
        const trigger = section.querySelector('.sf__sidebar-open');
        const isModal = modal(sidebar);
        const isOpen = isModal && section.classList.contains('sidebar-open');
        if (isOpen && sidebar.style.display !== 'block') sidebar.style.display = 'block';
        sidebar.inert = isModal && !isOpen;
        if (isModal && !isOpen) sidebar.setAttribute('aria-hidden','true');
        else sidebar.removeAttribute('aria-hidden');
        if (trigger) {
          trigger.setAttribute('aria-controls',sidebar.id);
          trigger.setAttribute('aria-expanded',String(isOpen));
        }
        if (isOpen && !activeDrawer) activate(sidebar,section,trigger);
        if (isOpen && activeDrawer?.sidebar === sidebar && !activeDrawer.dialog.contains(document.activeElement)) focusFirst(activeDrawer.dialog);
      });
      document.querySelectorAll('[data-section-type="page-faqs"] .sf__accordion-item').forEach(item=>{
        const button=item.querySelector('button.sf__accordion-button');
        const answer=item.querySelector('.sf__accordion-content');
        const open=item.classList.contains('open');
        if(button) button.setAttribute('aria-expanded',String(open));
        if(answer) { answer.inert=!open; if(open) answer.removeAttribute('aria-hidden'); else answer.setAttribute('aria-hidden','true'); }
      });
      document.querySelectorAll('.shopify-policy__body h1,.shopify-policy__body h2,.shopify-policy__body h3,.shopify-policy__body h4,.shopify-policy__body h5,.shopify-policy__body h6').forEach(heading=>{
        if(!heading.textContent.trim() && !heading.querySelector('img,svg')) heading.setAttribute('aria-hidden','true');
      });
      // Mirror the vendor's visual availability state in native control semantics.
      document.querySelectorAll('button.add-to-cart').forEach(button=>{
        if(button.classList.contains('disabled')) {
          if(!button.disabled) button.dataset.acDisabledByAvailability='true';
          button.disabled=true;
        } else if(button.dataset.acDisabledByAvailability==='true') {
          button.disabled=false;
          delete button.dataset.acDisabledByAvailability;
        }
      });
      document.querySelectorAll('.prod__dynamic_checkout').forEach(container=>{
        const unavailable=container.classList.contains('disabled');
        if(unavailable) {
          container.dataset.acHiddenByAvailability='true';
          container.hidden=true;
          container.inert=true;
          setAttribute(container,'aria-hidden','true');
        } else if(container.dataset.acHiddenByAvailability==='true') {
          container.hidden=false;
          container.inert=false;
          container.removeAttribute('aria-hidden');
          delete container.dataset.acHiddenByAvailability;
        }
      });
      syncImageViewer();
      enhanceNewsletterPopup();
      syncOverlays();
      enhanceBundles();
      syncCart();
    };
    document.addEventListener('keydown',event => {
      const dialog = activeImageViewer?.dialog || activeAddon?.dialog || activeOverlay?.dialog || activeDrawer?.dialog;
      if (!dialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        if (activeImageViewer) activeImageViewer.dialog.querySelector('.gclose')?.click();
        else if(activeAddon) activeAddon.closeButton?.click();
        else if(activeOverlay) activeOverlay.closeButton?.click();
        else activeDrawer.sidebar.querySelector('.sf__sidebar-close')?.click();
        sync();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = controls(dialog);
      const first = items[0];
      const last = items[items.length - 1];
      const current = document.activeElement;
      if (!first) {
        event.preventDefault();
        dialog.focus({preventScroll:true});
      } else if (event.shiftKey && (current === first || !items.includes(current))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (current === last || !items.includes(current))) {
        event.preventDefault();
        first.focus();
      }
    },true);
    document.addEventListener('focusin',event => {
      const dialog = activeImageViewer?.dialog || activeAddon?.dialog || activeOverlay?.dialog || activeDrawer?.dialog;
      if (dialog && !dialog.contains(event.target)) focusFirst(dialog);
    });
    document.addEventListener('click',event => {
      const popupSubmit=event.target.closest('.f-popup__submit');
      if(popupSubmit) {
        const input=popupSubmit.closest('.f-popup').querySelector('.f-popup__input');
        if(input && !input.checkValidity()) {
          event.preventDefault();event.stopImmediatePropagation();input.focus();return;
        }
      }
      const zoom = event.target.closest('.sf-prod-media__zoom-in');
      if (zoom) imageTrigger = zoom;
      const trigger=event.target.closest('button,a,[role="button"]');
      if(trigger) lastTrigger=trigger;
      if(trigger?.closest('[data-cart-wrapper],.scd__items') && trigger.getAttribute('aria-label')) pendingCartFocus=trigger.getAttribute('aria-label');
      const bundleButton=event.target.closest('[data-bundle-container] .select-button');
      if(bundleButton && event.detail === 0) pendingBundleFocus={button:bundleButton,pressed:bundleButton.getAttribute('aria-pressed')};
      if(event.target.closest('.sf-customer__reset-password-btn')) pendingAccountFocus='#ac-recover-email';
      if(event.target.closest('[data-recover-toggle]')) pendingAccountFocus='.sf-customer__reset-password-btn';
      if (event.target.closest('a[href="#MainContent"]')) document.getElementById('MainContent')?.focus({preventScroll:true});
    },true);
    document.addEventListener('keydown',event=> {
      if(event.key === 'Enter' && !event.isComposing && event.target.matches('.f-popup__input')) {event.preventDefault();event.target.closest('.f-popup').querySelector('.f-popup__submit')?.click();return;}
      if(['Enter',' '].includes(event.key) && event.target.matches('.sf-modal__close:not(button)')) {event.preventDefault();event.target.click();}
    });
    new MutationObserver(sync).observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','style','src']});
    window.addEventListener('resize',sync);
    window.addEventListener('pagehide',() => { releaseOverlay(activeAddon,false);releaseOverlay(activeOverlay,false);release(false);releaseImageViewer(false); });
    sync();
    const feedback=document.querySelector('[data-ac-form-feedback]');
    if(feedback && visible(feedback)) feedback.focus({preventScroll:false});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
